import { FC, memo } from 'react'
import { Stack, Heading, Text, Box, Flex } from '@chakra-ui/react'

import ImageItem from './components/ImageItem'
import { useUploadImage } from 'components/uploads/UploadImage/context/Provider'
import { ImagesFromUploadImage } from '../../../../../../types'

type Props = {
  selectedImage: ImagesFromUploadImage | undefined
  setSelectedImage: (newImage: ImagesFromUploadImage) => void
}

const ImageList: FC<Props> = ({ selectedImage, setSelectedImage }) => {
  const { texts, images } = useUploadImage()

  return (
    <Stack>
      <Stack spacing={0}>
        <Heading size="md">{texts?.imageListTitle || 'Minhas fotos'}</Heading>
        <Text>Clique em uma imagem e no botão respectivamente para trocar a foto atual</Text>
      </Stack>

      <Flex gap={4} align="center" flexWrap="wrap">
        {images.map((item) => (
          <Box key={item.url}>
            <ImageItem imageItem={item} selectedImage={selectedImage} setSelectedImage={setSelectedImage} />
          </Box>
        ))}
      </Flex>
    </Stack>
  )
}

export default memo(ImageList)
